import React from "react";
import { useNavigate } from "react-router-dom";

const UpperBackPT = () => {
  const navigate = useNavigate();

  return (
    <>
      <style>{`
        .ub-page {
          min-height: 100vh;
          width: 100%;
          background: radial-gradient(circle at top left, #ecfdf5 0, #f9fafb 40%, #e5e7eb 100%);
          font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
          color: #0f172a;
        }

        .ub-inner {
          max-width: 1200px;
          margin: 0 auto;
          padding: 32px 16px 72px;
        }

        /* HERO */
        .ub-hero {
          padding: 26px 22px 34px;
          border-radius: 28px;
          background: linear-gradient(120deg, rgba(34, 197, 94, 0.22), rgba(59, 130, 246, 0.08));
          margin-bottom: 36px;
          display: grid;
          grid-template-columns: minmax(0, 1.5fr) minmax(0, 1.1fr);
          gap: 24px;
          align-items: center;
        }

        @media (max-width: 820px) {
          .ub-hero {
            grid-template-columns: 1fr;
          }
        }

        .ub-tag {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 5px 12px;
          border-radius: 999px;
          background: rgba(34, 197, 94, 0.24);
          color: #166534;
          font-size: 12px;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.08em;
          margin-bottom: 8px;
        }

        .ub-tagDot {
          width: 6px;
          height: 6px;
          border-radius: 999px;
          background: #22c55e;
        }

        .ub-title {
          font-size: clamp(28px, 4vw, 38px);
          font-weight: 800;
          line-height: 1.1;
          margin-bottom: 10px;
        }

        .ub-subtitle {
          font-size: 15px;
          max-width: 560px;
          color: #374151;
        }

        .ub-chips {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          margin: 16px 0 18px;
        }

        .ub-chip {
          padding: 6px 12px;
          border-radius: 999px;
          background: #0f172a;
          color: #f9fafb;
          font-size: 11px;
        }

        .ub-ctaRow {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          margin-top: 10px;
        }

        .ub-btnPrimary,
        .ub-btnSecondary {
          border-radius: 999px;
          border: none;
          font-size: 14px;
          padding: 9px 18px;
          cursor: pointer;
          display: inline-flex;
          align-items: center;
          gap: 6px;
          transition: transform 0.12s ease, box-shadow 0.12s ease, background 0.12s ease;
        }

        .ub-btnPrimary {
          background: #16a34a;
          color: #ecfdf5;
          box-shadow: 0 10px 24px rgba(22, 163, 74, 0.38);
        }

        .ub-btnPrimary:hover {
          transform: translateY(-1px);
          box-shadow: 0 14px 32px rgba(22, 163, 74, 0.5);
        }

        .ub-btnSecondary {
          background: rgba(15, 23, 42, 0.06);
          color: #111827;
          border: 1px solid rgba(148, 163, 184, 0.7);
        }

        .ub-btnSecondary:hover {
          background: rgba(15, 23, 42, 0.1);
          transform: translateY(-1px);
        }

        .ub-heroImgWrap {
          display: flex;
          justify-content: center;
        }

        .ub-heroImg {
          width: 100%;
          max-width: 380px;
          border-radius: 24px;
          object-fit: cover;
          box-shadow: 0 18px 38px rgba(15, 23, 42, 0.24);
        }

        /* GENERIC SECTIONS */
        .ub-stripe {
          padding: 32px 0;
          border-bottom: 1px solid rgba(148, 163, 184, 0.35);
        }

        .ub-sectionTitle {
          font-size: 21px;
          font-weight: 800;
          margin-bottom: 8px;
        }

        .ub-sectionSubtitle {
          font-size: 14px;
          color: #4b5563;
          margin-bottom: 18px;
        }

        .ub-flexRow {
          display: flex;
          flex-wrap: wrap;
          gap: 24px;
          align-items: center;
        }

        .ub-flexCol {
          flex: 1 1 260px;
        }

        .ub-img {
          width: 100%;
          max-width: 360px;
          border-radius: 22px;
          object-fit: cover;
          box-shadow: 0 14px 30px rgba(15, 23, 42, 0.18);
        }

        /* LISTS */
        .ub-list {
          list-style: none;
          padding: 0;
          margin: 0;
          display: grid;
          gap: 8px;
        }

        .ub-list li {
          display: flex;
          gap: 8px;
          font-size: 14px;
          color: #111827;
        }

        .ub-bullet {
          width: 7px;
          height: 7px;
          border-radius: 999px;
          background: #16a34a;
          margin-top: 6px;
          flex-shrink: 0;
        }

        /* CARD GRID */
        .ub-cardGrid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
          gap: 16px;
          margin-top: 18px;
        }

        .ub-card {
          padding: 12px 14px;
          border-radius: 18px;
          background: rgba(15, 23, 42, 0.02);
          border: 1px solid rgba(148, 163, 184, 0.5);
        }

        .ub-cardTitle {
          font-size: 13px;
          font-weight: 700;
          margin-bottom: 4px;
        }

        .ub-cardText {
          font-size: 12px;
          color: #4b5563;
        }

        /* TIMELINE */
        .ub-timeline {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
          gap: 10px;
        }

        .ub-step {
          padding: 10px 12px;
          border-radius: 18px;
          background: rgba(15, 23, 42, 0.03);
        }

        .ub-stepLabel {
          font-size: 12px;
          font-weight: 700;
          margin-bottom: 4px;
        }

        .ub-stepText {
          font-size: 12px;
          color: #4b5563;
        }

        /* BANNER */
        .ub-banner {
          position: relative;
          border-radius: 26px;
          overflow: hidden;
          margin-top: 24px;
        }

        .ub-banner img {
          width: 100%;
          height: 240px;
          object-fit: cover;
          display: block;
        }

        @media (min-width: 768px) {
          .ub-banner img {
            height: 270px;
          }
        }

        .ub-bannerOverlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(90deg, rgba(15, 23, 42, 0.8), transparent 60%);
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding: 18px 20px;
          gap: 10px;
        }

        .ub-bannerText {
          color: #dcfce7;
          font-size: 15px;
          max-width: 420px;
        }

        .ub-bannerButtons {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
        }

        .ub-bannerButtons button {
          font-size: 12px;
          padding: 8px 14px;
          border-radius: 999px;
          border: none;
          cursor: pointer;
        }

        .ub-bannerButtons .primary {
          background: #22c55e;
          color: #022c22;
        }

        .ub-bannerButtons .secondary {
          background: rgba(255,255,255,0.18);
          color: #f9fafb;
          border: 1px solid rgba(255,255,255,0.6);
        }

        /* BOTTOM STRIP */
        .ub-bottomStrip {
          margin-top: 24px;
          padding: 14px 14px;
          border-radius: 22px;
          background: #0f172a;
          display: flex;
          flex-wrap: wrap;
          gap: 12px;
          align-items: center;
          justify-content: space-between;
        }

        .ub-bottomText {
          font-size: 12px;
          color: #e5e7eb;
          flex: 1 1 240px;
        }

        .ub-bottomText strong {
          color: #fef9c3;
        }

        .ub-bottomActions {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
        }

        .ub-bottomActions button {
          font-size: 12px;
          padding: 7px 12px;
          border-radius: 999px;
          border: none;
          cursor: pointer;
        }

        .ub-bottomActions .primary {
          background: #16a34a;
          color: #ecfdf5;
        }

        .ub-bottomActions .secondary {
          background: transparent;
          color: #e5e7eb;
          border: 1px solid rgba(148, 163, 184, 0.8);
        }

        @media (max-width: 640px) {
          .ub-title {
            font-size: 26px;
          }
        }
      `}</style>

      <div className="ub-page">
        <div className="ub-inner">
          {/* HERO */}
          <section className="ub-hero">
            <div>
              <div className="ub-tag">
                <span className="ub-tagDot" />
                Upper Back & Shoulder Girdle
              </div>
              <h1 className="ub-title">
                Ease upper back tightness so breathing, reaching, and sitting feel easier.
              </h1>
              <p className="ub-subtitle">
                Your upper back and shoulder blade muscles work together to support posture, shoulder motion,
                and even how your neck feels. When they&apos;re stiff or overworked, you might feel tightness,
                burning, or fatigue between the shoulder blades.
              </p>

              <div className="ub-chips">
                <span className="ub-chip">Mid-back tightness</span>
                <span className="ub-chip">Between-shoulder blade pain</span>
                <span className="ub-chip">Posture fatigue</span>
                <span className="ub-chip">Shoulder blade discomfort</span>
              </div>

              <div className="ub-ctaRow">
                <button
                  className="ub-btnPrimary"
                  onClick={() => navigate("/appointments")}
                >
                  Book an upper back visit →
                </button>
                <button
                  className="ub-btnSecondary"
                  onClick={() => navigate("/staff")}
                >
                  Meet our therapists
                </button>
              </div>
            </div>

            <div className="ub-heroImgWrap">
              <img
                src="/content/upper-back/upper_back_hero.png"
                alt="Therapist assessing upper back region"
                className="ub-heroImg"
              />
            </div>
          </section>

          {/* WHAT CAN GO WRONG */}
          <section className="ub-stripe">
            <div className="ub-sectionTitle">What can go wrong in the upper back?</div>
            <p className="ub-sectionSubtitle">
              The thoracic spine, trapezius, rhomboids, lats, and rotator cuff all coordinate to move and
              support the shoulder girdle. When that team gets out of balance, certain areas can start to complain.
            </p>

            <div className="ub-flexRow">
              <div className="ub-flexCol">
                <ul className="ub-list">
                  <li>
                    <span className="ub-bullet" />
                    <span>
                      <strong>Thoracic spine stiffness:</strong> a rigid or rounded mid-back that makes it hard
                      to sit tall or rotate comfortably.
                    </span>
                  </li>
                  <li>
                    <span className="ub-bullet" />
                    <span>
                      <strong>Rhomboid & middle trap soreness:</strong> aching or burning between the shoulder blades,
                      especially after computer work or driving.
                    </span>
                  </li>
                  <li>
                    <span className="ub-bullet" />
                    <span>
                      <strong>Lower trapezius fatigue:</strong> difficulty maintaining good shoulder blade position
                      when reaching or lifting.
                    </span>
                  </li>
                  <li>
                    <span className="ub-bullet" />
                    <span>
                      <strong>Latissimus dorsi tightness:</strong> pulling along the side of the mid-back that can
                      limit shoulder overhead motion.
                    </span>
                  </li>
                  <li>
                    <span className="ub-bullet" />
                    <span>
                      <strong>Rotator cuff overload:</strong> shoulder discomfort that&apos;s closely tied to how
                      the shoulder blade moves on the rib cage.
                    </span>
                  </li>
                </ul>

                <div className="ub-ctaRow" style={{ marginTop: "14px" }}>
                  <button
                    className="ub-btnPrimary"
                    onClick={() => navigate("/appointments")}
                  >
                    See if your symptoms match →
                  </button>
                  <button
                    className="ub-btnSecondary"
                    onClick={() => navigate("/contact")}
                  >
                    Ask a quick question
                  </button>
                </div>
              </div>

              <div className="ub-flexCol" style={{ display: "flex", justifyContent: "center" }}>
                <img
                  src="/content/upper-back/upper_back_thoracic_spine.png"
                  alt="Therapist guiding thoracic spine mobility"
                  className="ub-img"
                />
              </div>
            </div>

            <div className="ub-cardGrid">
              <div className="ub-card">
                <div className="ub-cardTitle">Thoracic Spine</div>
                <div className="ub-cardText">
                  The mid-back region that allows rotation and extension; often stiff with prolonged sitting.
                </div>
              </div>
              <div className="ub-card">
                <div className="ub-cardTitle">Middle & Lower Trapezius</div>
                <div className="ub-cardText">
                  Help position and stabilize the shoulder blades for overhead and pulling movements.
                </div>
              </div>
              <div className="ub-card">
                <div className="ub-cardTitle">Rhomboids</div>
                <div className="ub-cardText">
                  Muscles between the shoulder blades that retract and support posture.
                </div>
              </div>
              <div className="ub-card">
                <div className="ub-cardTitle">Latissimus Dorsi</div>
                <div className="ub-cardText">
                  Large side-back muscle important for pulling, reaching, and controlling shoulder motion.
                </div>
              </div>
            </div>
          </section>

          {/* RHOMBOIDS & MID-SCAP REGION */}
          <section className="ub-stripe">
            <div className="ub-flexRow">
              <div className="ub-flexCol">
                <img
                  src="/content/upper-back/upper_back_rhomboids.png"
                  alt="Manual therapy along rhomboid region"
                  className="ub-img"
                />
              </div>

              <div className="ub-flexCol">
                <div className="ub-sectionTitle">“Knot between the shoulder blades” feeling</div>
                <p className="ub-sectionSubtitle">
                  That stubborn spot between the shoulder blades is often your rhomboids and mid traps trying
                  to hold posture without enough help from nearby muscles.
                </p>

                <ul className="ub-list">
                  <li>
                    <span className="ub-bullet" />
                    <span>
                      Localized soreness between the shoulder blades after long days.
                    </span>
                  </li>
                  <li>
                    <span className="ub-bullet" />
                    <span>
                      A “burning band” feeling across the upper back with computer work.
                    </span>
                  </li>
                  <li>
                    <span className="ub-bullet" />
                    <span>
                      Temporary relief with stretching, rolling, or massage, but it keeps coming back.
                    </span>
                  </li>
                </ul>

                <div className="ub-ctaRow" style={{ marginTop: "14px" }}>
                  <button
                    className="ub-btnPrimary"
                    onClick={() => navigate("/appointments")}
                  >
                    Start upper back PT →
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* HOW PT HELPS */}
          <section className="ub-stripe">
            <div className="ub-flexRow">
              <div className="ub-flexCol">
                <div className="ub-sectionTitle">How physical therapy supports the upper back</div>
                <p className="ub-sectionSubtitle">
                  We look at how your thoracic spine, shoulder blades, and shoulders share the work of posture,
                  breathing, and reaching.
                </p>

                <ul className="ub-list">
                  <li>
                    <span className="ub-bullet" />
                    <span>
                      <strong>Thoracic mobility work:</strong> gentle movements and hands-on techniques to help
                      the mid-back move more freely.
                    </span>
                  </li>
                  <li>
                    <span className="ub-bullet" />
                    <span>
                      <strong>Soft-tissue techniques:</strong> for rhomboids, traps, lats, and surrounding muscles
                      that may be holding tension.
                    </span>
                  </li>
                  <li>
                    <span className="ub-bullet" />
                    <span>
                      <strong>Scapular control training:</strong> teaching shoulder blades to move smoothly
                      during reaching and pulling.
                    </span>
                  </li>
                  <li>
                    <span className="ub-bullet" />
                    <span>
                      <strong>Simple posture strategies:</strong> small, realistic changes to your setup that
                      reduce strain without needing “perfect posture.”
                    </span>
                  </li>
                </ul>

                <div className="ub-ctaRow" style={{ marginTop: "14px" }}>
                  <button
                    className="ub-btnPrimary"
                    onClick={() => navigate("/appointments")}
                  >
                    Book an upper back session →
                  </button>
                  <button
                    className="ub-btnSecondary"
                    onClick={() => navigate("/insurance")}
                  >
                    Check my insurance
                  </button>
                </div>
              </div>

              <div className="ub-flexCol">
                <img
                  src="/content/upper-back/upper_back_lower_traps.png"
                  alt="Lower trapezius activation exercise"
                  className="ub-img"
                />
              </div>
            </div>
          </section>

          {/* ROTATOR CUFF & SHOULDER GIRDLE */}
          <section className="ub-stripe">
            <div className="ub-sectionTitle">How the upper back and rotator cuff work together</div>
            <p className="ub-sectionSubtitle">
              A strong, mobile upper back gives the rotator cuff a better base to work from. If the shoulder
              blade can&apos;t move well on the ribs, shoulder mechanics can feel pinchy or weak.
            </p>

            <div className="ub-flexRow">
              <div className="ub-flexCol">
                <div className="ub-timeline">
                  <div className="ub-step">
                    <div className="ub-stepLabel">1. Shoulder blade foundation</div>
                    <div className="ub-stepText">
                      We check how your shoulder blades glide on your rib cage when you lift, reach, or pull.
                    </div>
                  </div>
                  <div className="ub-step">
                    <div className="ub-stepLabel">2. Rotator cuff check</div>
                    <div className="ub-stepText">
                      We look at specific rotator cuff muscles that stabilize the shoulder joint itself.
                    </div>
                  </div>
                  <div className="ub-step">
                    <div className="ub-stepLabel">3. Coordinated exercises</div>
                    <div className="ub-stepText">
                      You practice movements that pair upper back motion with controlled shoulder work.
                    </div>
                  </div>
                  <div className="ub-step">
                    <div className="ub-stepLabel">4. Progress to real life</div>
                    <div className="ub-stepText">
                      We build toward your daily tasks—like lifting, carrying, or reaching overhead—without flare-ups.
                    </div>
                  </div>
                </div>

                <div className="ub-ctaRow" style={{ marginTop: "14px" }}>
                  <button
                    className="ub-btnPrimary"
                    onClick={() => navigate("/appointments")}
                  >
                    Book an upper back & shoulder eval →
                  </button>
                </div>
              </div>

              <div className="ub-flexCol">
                <img
                  src="/content/upper-back/upper_back_rotator_cuff.png"
                  alt="Rotator cuff and shoulder blade assessment"
                  className="ub-img"
                />
              </div>
            </div>
          </section>

          {/* BANNER */}
          <section className="ub-stripe">
            <div className="ub-banner">
              <img
                src="/content/upper-back/upper_back_banner.png"
                alt="Bright PT clinic for upper back and shoulder care"
              />
              <div className="ub-bannerOverlay">
                <div className="ub-bannerText">
                  Upper back sessions happen in a calm, one-on-one environment where we match your plan
                  to your work, daily life, and activity goals.
                </div>
                <div className="ub-bannerButtons">
                  <button
                    className="primary"
                    onClick={() => navigate("/appointments")}
                  >
                    Schedule an upper back visit →
                  </button>
                  <button
                    className="secondary"
                    onClick={() => navigate("/office")}
                  >
                    View locations
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* SAFETY NOTE */}
          <section className="ub-stripe">
            <div className="ub-bottomStrip">
              <div className="ub-bottomText">
                If you notice sudden severe upper back pain with chest pain, trouble breathing, jaw or arm pain,
                unexplained sweating, or feel unwell in a way that&apos;s new,{" "}
                <strong>seek emergency or medical care immediately.</strong> Once serious causes are ruled out,
                physical therapy can help you safely rebuild comfort and strength.
              </div>
              <div className="ub-bottomActions">
                <button
                  className="primary"
                  onClick={() => navigate("/appointments")}
                >
                  Schedule upper back PT
                </button>
                <button
                  className="secondary"
                  onClick={() => navigate("/contact")}
                >
                  Message our team
                </button>
              </div>
            </div>
          </section>

        </div>
      </div>
    </>
  );
};

export default UpperBackPT;
